<template>
    <div>
       <v-card
        tile
       >
       <v-card-title>Add Guest Writer</v-card-title>
       <v-divider/>
       <v-card-text>
           <v-form ref="form" v-model="isValid">
               <v-text-field
                filled
                v-model="params.name"
                v-bind:rules="validation.name"
                label="Name"
               >
               </v-text-field>
               <v-textarea
                filled
                v-model="params.address"
                label="Address"
               >
               </v-textarea>
               <v-textarea
                filled
                v-model="params.about"
                label="About"
               >
               </v-textarea>
               <v-file-input
                filled
                label="Photo"
                accept = "image/*"
                v-model="params.avatar"
                prepend-icon="mdi-camera"
                show-size
                counter
               >
               </v-file-input>
           </v-form>
       </v-card-text>
       <v-divider/>
       <v-card-actions>
           <v-btn
            tile
            color="primary"
            v-bind:disabled="isSubmitting || !isValid"
            class="mx-2"
            :loading="isSubmitting"
            v-on:click="submit"
           >Submit</v-btn>
       </v-card-actions>
       </v-card>
    </div>
</template>

<script>
import guestWriterApi from '@/api/gwApi'
import snackbar from '@/utils/snackbar'
export default {
  data () {
    return {
      isValid: false,
      params: {
        name: '',
        address: '',
        about: '',
        avatar: null
      },
      isSubmitting: false,
      validation: {
        name: [(v) => !!v || 'Name is required']
      }
    }
  },
  methods: {
    async submit () {
      try {
        this.isSubmitting = true
        await guestWriterApi.addGuestWriter(this.params)
        snackbar.show('Guest writer added successfully', 'success')
        this.$router.push({ path: '/guestwriter', replace: true })
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>
